module.exports = __webpack_public_path__ + "media/images/lb/466-a29c402e24c5395682dde04c8323ac07.svg";